import { USER_ROLES } from "@/constants/auth";
import { API_KEYS_PAGE, AUDIT_LOGS_PAGE, CONTRACTS_PAGE, DASHBOARD_PAGE, INVOICES_PAGE, ORGANIZATION_PAGE, USAGE_PAGE, UTILIZATION_DEEP_DIVE_PAGE } from "@/router/paths";
const CONTRACTS_ALLOWED_ROLES = [
    USER_ROLES.ADMIN,
    USER_ROLES.VIEWER,
    USER_ROLES.SUPERADMIN
];
const CLUSTER_RESTRICTED_PAGES = [
    DASHBOARD_PAGE,
    API_KEYS_PAGE,
    USAGE_PAGE,
    UTILIZATION_DEEP_DIVE_PAGE,
    INVOICES_PAGE,
    AUDIT_LOGS_PAGE
];
function canAccessContracts(userRole) {
    return CONTRACTS_ALLOWED_ROLES.some((role)=>role === userRole);
}
function getDefaultPortalPage(userRole, isClusterOnlyCustomer) {
    if (!isClusterOnlyCustomer) return DASHBOARD_PAGE;
    return canAccessContracts(userRole) ? CONTRACTS_PAGE : ORGANIZATION_PAGE;
}
function canAccessPortalPath(pathname, isClusterOnlyCustomer) {
    return !isClusterOnlyCustomer || !CLUSTER_RESTRICTED_PAGES.some((path)=>path === pathname);
}
export { CLUSTER_RESTRICTED_PAGES, CONTRACTS_ALLOWED_ROLES, canAccessContracts, canAccessPortalPath, getDefaultPortalPage };
